/**
 * StatusBadge - Componente base reutilizable para badges de estado con pill + dot.
 * Usa clases Tailwind con variantes dark: para soporte automático de tema.
 */

export interface StatusBadgeClasses {
  pill: string;
  dot: string;
}

interface StatusBadgeProps {
  label: string;
  classes: StatusBadgeClasses;
  className?: string;
}

export function StatusBadge({ label, classes, className }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${classes.pill} ${className ?? ""}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${classes.dot}`} />
      {label}
    </span>
  );
}
